/**
 * @fileOverview ViewStore for mouse handling date picker from React component.
 * @author jzetlen
 *
 */

import moment from 'moment';
import invariant from 'invariant-slim';
import trackLink from 'view/activity/trackLink';

export default function mouseHandling({ minDate, maxDate }) {
	return function ({ getState, updateState, onUpdate, publish }) {
		return {
			onClickMonthName: (event) => {
				const { showMonth } = getState();
				publish(event, ...getMonthRangeFromDate(
					{ minDate, maxDate },
					showMonth
				));
				trackLink('opencalendar:header:' + moment(showMonth).format('MM YYYY'));
			},
			onClickPrev: (event, showMonth) => {
				if (!moment(showMonth).endOf('month').isBefore(minDate)) {
					trackLink('opencalendar:prevmonth');
					updateState({ showMonth });
				}
			},
			onClickNext: (event, showMonth) => {
				if (!moment(showMonth).startOf('month').isAfter(maxDate)) {
					trackLink('opencalendar:nextmonth');
					updateState({ showMonth });
				}
			},
			onClickDay: (event, day) => {
				if (!day.valid) {
					return false;
				}
				const {
					hoverAnchor,
					onHoverDay,
					onClickDay,
					editing,
					startDate,
					endDate
				} = getState();
				invariant(
					editing === 'start' || editing === 'end',
					'editing unknown!'
				);
				const thisDay = moment(day.date);
				// to reconcile mobile where hover events don't fire
				if (hoverAnchor) {
					onHoverDay(event, day);
					updateState({ hoverAnchor: false });
					return onClickDay(event, day);
				}
				if (editing === 'start' && !thisDay.isAfter(endDate)) {
					publish(event, day.date, endDate);
				} else if (editing === 'end' && !thisDay.isBefore(startDate)) {
					publish(event, startDate, day.date);
				} else {
					updateState({
						editing: 'start',
						hoverAnchor: day.date,
						startDate: day.date,
						endDate: day.date
					});
				}
			},
			onHoverDay: (event, day) => {
				const { hoverAnchor } = getState();
				if (hoverAnchor) {
					if (moment(day.date).isBefore(hoverAnchor)) {
						updateState({
							editing: 'start',
							startDate: day.date,
							endDate: hoverAnchor
						});
					} else if (day.valid) {
						updateState({
							editing: 'end',
							startDate: hoverAnchor,
							endDate: day.date
						});
					}
				}
			},
			onClickAway: close,
			onClickClose: close
		};
		function close () {
			updateState({ editing: false, hoverAnchor: false });
		}
	};
}

export const getMonthRangeFromDate = ({ minDate, maxDate }, dateInMonth) => {
	const start = moment(dateInMonth).startOf('month'),
		monthEnd = start.clone().endOf('month'),
		startDate = start.isBefore(minDate) ? minDate : start.toDate(),
		endDate = monthEnd.isAfter(maxDate) ? maxDate : monthEnd.toDate();
	return [startDate, endDate];
};



// WEBPACK FOOTER //
// ./view/activity/dateRangePicker/stores/mouseHandling.es6